import apiClient from '../../api/apiClient';
import { User, UserCreate, UserUpdate, Role } from './usersSlice';

// API URL'ini çevre değişkenlerinden al veya varsayılan değeri kullan
const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api/v1';
const USERS_ENDPOINT = '/users';

// Kullanıcı servisi
const usersService = {
  // Kullanıcıları getir
  getUsers: async (params: { 
    page?: number; 
    limit?: number; 
    status?: string; 
    role_id?: number; 
    company_id?: number;
    search?: string;
  }) => {
    const { page = 1, limit = 10, ...filters } = params;
    const skip = (page - 1) * limit;
    
    // Filtre parametrelerini oluştur
    const queryParams = new URLSearchParams();
    queryParams.append('skip', skip.toString());
    queryParams.append('limit', limit.toString());
    
    // Diğer filtreleri ekle
    Object.entries(filters).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        queryParams.append(key, value.toString());
      }
    });
    
    const response = await apiClient.get(`${USERS_ENDPOINT}?${queryParams.toString()}`);
    
    // Backend'den dönen yanıt doğrudan kullanıcı dizisi olabilir, biz onu daha zengin bir yanıta dönüştürüyoruz
    return {
      users: response,
      total: response.length, // Backend total dönmüyorsa, dizi uzunluğunu kullanabiliriz
      page,
      limit
    };
  },
  
  // Kullanıcı detaylarını getir
  getUserById: async (userId: number): Promise<User> => {
    return await apiClient.get(`${USERS_ENDPOINT}/${userId}`);
  },
  
  // Yeni kullanıcı oluştur
  createUser: async (userData: UserCreate): Promise<User> => {
    return await apiClient.post(USERS_ENDPOINT, userData);
  },
  
  // Kullanıcı güncelle
  updateUser: async (userId: number, userData: UserUpdate): Promise<User> => {
    return await apiClient.put(`${USERS_ENDPOINT}/${userId}`, userData);
  },
  
  // Kullanıcı sil
  deleteUser: async (userId: number): Promise<void> => {
    return await apiClient.delete(`${USERS_ENDPOINT}/${userId}`);
  },

  // Agency Owner'ın marketing specialist'larını getir
  getMyAgencyMarketingSpecialists: async (): Promise<User[]> => {
    return await apiClient.get(`${USERS_ENDPOINT}/my-agency/marketing-specialists`);
  },

  // Agency Owner'ın tüm şirketlerindeki kullanıcıları getir
  getMyCompaniesUsers: async (): Promise<User[]> => {
    return await apiClient.get(`${USERS_ENDPOINT}/my-companies/users`);
  },

  // Agency'deki tüm kullanıcıları getir (listeleme için)
  getAgencyUsers: async (agencyId: number): Promise<User[]> => {
    return await apiClient.get(`${USERS_ENDPOINT}/agency/${agencyId}/users`);
  },

  // Agency'deki kullanıcı detayını getir
  getAgencyUserDetail: async (agencyId: number, userId: number): Promise<User> => {
    return await apiClient.get(`${USERS_ENDPOINT}/agency/${agencyId}/users/${userId}`);
  },

  // Agency'deki kullanıcıyı güncelle
  updateAgencyUser: async (agencyId: number, userId: number, userData: any): Promise<User> => {
    return await apiClient.put(`${USERS_ENDPOINT}/agency/${agencyId}/users/${userId}`, userData);
  },

  // Agency'deki kullanıcıyı sil
  deleteAgencyUser: async (agencyId: number, userId: number): Promise<void> => {
    return await apiClient.delete(`${USERS_ENDPOINT}/agency/${agencyId}/users/${userId}`);
  },

  // Kullanıcıları şirkete ata
  assignUsersToCompany: async (companyId: number, userIds: number[]): Promise<User[]> => {
    return await apiClient.post(`${USERS_ENDPOINT}/assign-to-company`, {
      company_id: companyId,
      user_ids: userIds
    });
  },

  // Rolleri getir
  getRoles: async (): Promise<Role[]> => {
    return await apiClient.get('/roles');
  },

  // Kullanıcının şirketlerini getir
  getMyCompanies: async (): Promise<any[]> => {
    return await apiClient.get('/companies/my-companies');
  }
};

export default usersService;